import { ChevronDown, Loader2 } from "lucide-react";

const SelectField = ({
  label,
  name,
  value,
  defaultValue,
  onChange,
  options = [],
  renderOption = null,
  placeholder = "Please Select",
  className = "",
  style = {},
  error = "",
  required = false,
  disabled = false,
  Icon = null,
  IconRight = <ChevronDown />,
  children,
  loading = false,
}) => {
  return (
    <div className={`icon-form-group ${className}`} style={style}>
      {label && (
        <label htmlFor={name} className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="icon-input">
        {Icon && <span className="icon left">{Icon}</span>}

        <select
          name={name}
          id={name}
          value={value !== undefined && value !== null ? value : defaultValue}
          defaultValue={defaultValue}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={`form-select ${error ? "is-invalid" : ""} ${disabled ? "disabled" : ""
            }`}
        >
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {children}
          {renderOption && renderOption}
          {options != null && options.length > 0
            ? options.map((opt, idx) => (
              <option
                key={idx}
                disabled={opt.disabled || false}
                value={opt.value}
              >
                {opt.label}
              </option>
            ))
            : ""}
          {/* <option disabled>No Data Found</option> */}
        </select>

        {loading && (
          <span className="icon left">
            {loading ? <Loader2 className="spin" /> : IconRight && IconRight}
          </span>
        )}

        {error && <div className="invalid-feedback">{error}</div>}
      </div>
    </div>
  );
};

export default SelectField;
